/* ══ v14.3 (a): THE ACTIVITY LEDGER — ITS OWN FILE, PER WRITER ═════════════════════════════
   A permanent, append-only record of who published what. ⚠ IT IS A SECOND FILE, NOT A KEY IN
   THE PART, and the reasons are in §v14.3: the part is parsed at every boot, rewritten whole at
   every save and byte-checked by _partCanaryOk, so unbounded history has no business inside its
   blast radius; `_parsePartText`'s whitelist would refuse an unknown key and make it a schema
   change; and above all A SEPARATE FILE NEED NOT BE READ AT BOOT — the ledger is fetched only
   when the Activity view is opened, so its size can never cost boot or Save a millisecond.

   Same shape as a part in every way that matters: one file per writer, you only ever write your
   own, born lazily on first use, PARSED and never executed, and it merges by concatenation
   because nobody else can write yours. */
const LOG_STEM = 'TrendAI_FlightDeck_log';
const LOG_VERSION = 1;
function _logFileName(user, machine) {
  const w = _composeWriterId(user, machine);
  return w ? (LOG_STEM + '.' + w + '.js') : '';
}
function _myLogFileName() { return _logFileName(_writerUser, _writerMachine); }
/* ⚠ v14.3 (a) ◆2: the folder sentry must know these are OURS. Without this the app warns the
   user about files it wrote itself — the same shape as v14 (W6) teaching it about parts. */
const LOG_RE = new RegExp('^' + LOG_STEM.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') +
                          '\\.[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]+\\.js$');
function _isLogFileName(name) { return LOG_RE.test(String(name || '')); }

const LOG_PREFIX = 'window.__LOG__ = {\n';
const LOG_SUFFIX = '\n};';
const LOG_ENTRIES_OPEN = '  entries: [\n';
const LOG_ENTRIES_CLOSE = '\n  ]';
const LOG_SCALARS = [
  { key: 'logVersion', re: /^  logVersion: (-?\d+),$/ },
  { key: 'writer',     re: /^  writer: ("(?:[^"\\]|\\.)*"),$/ }
];

/* Byte-exact round-trip, exactly as serializeDB is for a part: serializeLog(parseLog(t)) === t.
   One entry per line so an append is a diff of one line, and _revStable so key order is
   deterministic and two structurally equal entries are textually equal. */
function serializeLog(log) {
  const entries = Array.isArray(log && log.entries) ? log.entries : [];
  let s = '/* TrendAI FlightDeck — activity log (' + APP_VERSION + ') — written by the app.\n' +
          '   One entry per save. Append-only: the app never edits or deletes an entry.\n' +
          '   ⚠ Not hand-edited, and never shared — you only ever write your own. */\n';
  s += LOG_PREFIX;
  s += '  logVersion: ' + (log && log.logVersion | 0 || LOG_VERSION) + ',\n';
  s += '  writer: ' + JSON.stringify(String((log && log.writer) || '')) + ',\n';
  s += LOG_ENTRIES_OPEN;
  for (let i = 0; i < entries.length; i++) {
    s += _revStable(entries[i]);
    if (i < entries.length - 1) s += ',';
    s += '\n';
  }
  /* the entries block always ends with a newline from the loop, or is empty */
  s = s.replace(/\n$/, '');
  s += LOG_ENTRIES_CLOSE + LOG_SUFFIX;
  return s;
}

/* ⚠ PARSED, NEVER EXECUTED — the same rule as a part, for the same reason: a colleague's file
   is not code we are willing to run. Anything outside the shape THROWS rather than being
   ignored, so a damaged log is refused by name instead of silently half-read. */
function _parseLogText(text, label) {
  const at = label ? (' in ' + label) : '';
  if (typeof text !== 'string' || !text.trim()) throw new Error('That activity log is empty' + at + '.');
  const t = text.replace(/\r\n/g, '\n');
  let i = 0;
  for (;;) {
    while (i < t.length && /\s/.test(t.charAt(i))) i++;
    if (t.charAt(i) === '/' && t.charAt(i + 1) === '*') {
      const e = t.indexOf('*/', i + 2);
      if (e === -1) throw new Error('Unterminated comment' + at + '.');
      i = e + 2;
      continue;
    }
    break;
  }
  if (t.slice(i, i + LOG_PREFIX.length) !== LOG_PREFIX)
    throw new Error('That is not a TrendAI activity log' + at + '.');
  let end = t.length;
  while (end > 0 && /\s/.test(t.charAt(end - 1))) end--;
  if (t.slice(end - LOG_SUFFIX.length, end) !== LOG_SUFFIX)
    throw new Error('That activity log does not end where one ends' + at + '.');
  const body = t.slice(i + LOG_PREFIX.length, end - LOG_SUFFIX.length);
  const k = body.indexOf('\n' + LOG_ENTRIES_OPEN);
  const head = (k === -1) ? null : body.slice(0, k);
  if (head === null) throw new Error('No entries block' + at + '.');
  if (body.slice(body.length - LOG_ENTRIES_CLOSE.length) !== LOG_ENTRIES_CLOSE)
    throw new Error('The entries block is not closed as expected' + at + '.');
  const inner = body.slice(k + 1 + LOG_ENTRIES_OPEN.length, body.length - LOG_ENTRIES_CLOSE.length);
  const out = {};
  const lines = head.split('\n');
  for (let n = 0; n < lines.length; n++) {
    let hit = null;
    for (let s = 0; s < LOG_SCALARS.length && !hit; s++) {
      const m = LOG_SCALARS[s].re.exec(lines[n]);
      if (m) hit = { key: LOG_SCALARS[s].key, raw: m[1] };
    }
    if (!hit) throw new Error('Unexpected line in the activity log' + at + ': ' + JSON.stringify(lines[n].slice(0, 60)));
    if (Object.prototype.hasOwnProperty.call(out, hit.key)) throw new Error('Duplicate "' + hit.key + '"' + at + '.');
    out[hit.key] = JSON.parse(hit.raw);
  }
  out.entries = inner.trim() ? JSON.parse('[' + inner + ']') : [];
  if (typeof out.logVersion !== 'number') throw new Error('That activity log states no version' + at + '.');
  if (!Array.isArray(out.entries)) throw new Error('entries is not a list' + at + '.');
  return out;
}

